import { render, staticRenderFns } from "./MoveAccountModal.vue?vue&type=template&id=2e472bc6&scoped=true&"
import script from "./MoveAccountModal.vue?vue&type=script&lang=js&"
export * from "./MoveAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveAccountModal.vue?vue&type=style&index=0&id=2e472bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e472bc6",
  null
  
)

export default component.exports